import React from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
export function HeroTestimonials() {
  const testimonials = [{
    text: 'En 3 meses conseguí mi primer cliente. Nunca pensé que podía.',
    author: 'María G.',
    details: '47 años — Córdoba'
  }, {
    text: 'Todo se entiende desde la primera página. Es para mí.',
    author: 'Claudia P.',
    details: '52 años — Rosario'
  }];
  return <section className="bg-nightDeep py-8 border-y border-white/10" data-id="element-166">
      <div className="max-w-5xl mx-auto px-6" data-id="element-167">
        <div className="grid md:grid-cols-2 gap-6" data-id="element-168">
          {testimonials.map((t, idx) => <motion.div key={idx} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: idx * 0.1
        }} className="glass p-6 rounded-2xl flex flex-col items-center text-center" data-id="element-169">
              <div className="flex gap-1 mb-3" data-id="element-170">
                {[1, 2, 3, 4, 5].map(s => <Star key={s} className="w-5 h-5 text-gold-accent fill-current" data-id="element-171" />)}
              </div>
              <p className="text-white font-medium italic mb-4 text-lg" data-id="element-172">
                "{t.text}"
              </p>
              <div className="mt-auto" data-id="element-173">
                <p className="font-bold text-gold-accent" data-id="element-174">{t.author}</p>
                <p className="text-sm text-textLight" data-id="element-175">{t.details}</p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}